import { render, staticRenderFns } from "./PatientDetailsList.vue?vue&type=template&id=8ce02c36&scoped=true"
import script from "./PatientDetailsList.vue?vue&type=script&lang=js"
export * from "./PatientDetailsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ce02c36",
  null
  
)

export default component.exports